<template>
  <div class="order">
    <Header title="确认订单" style="background-color: #fff;"></Header>
    <div class="main-cont1">
      <div class="title-box">
        <h1 style="font-weight: bold;">商品详情</h1>
        <img src="@/assets/imgs/plansale/3.1 返回1@2x.png" alt="" @click="toggleShow">
      </div>
      <div class="content-box" v-if="showDetails">
        <div>
          <span class="content-box-title">产品分类</span>
          <span class="content-box-info">{{ orderDetailData.commodityCategory }}</span>
        </div>
        <div>
          <span class="content-box-title">产品名称</span>
          <span class="content-box-info">{{ orderDetailData.commodityName }}</span>
        </div>
        <div>
          <span class="content-box-title">属性描述</span>
          <span class="content-box-info">{{ orderDetailData.description  }}</span>
        </div>
        <div>
          <span class="content-box-title">生产厂家</span>
          <span class="content-box-info">{{ orderDetailData.productionEnterprise }}</span>
        </div>
        <div>
          <span class="content-box-title">挂牌编号</span>
          <span class="content-box-info">{{ orderDetailData.tradeNo ? orderDetailData.tradeNo : '-'}}</span>
        </div>
        <div>
          <span class="content-box-title">仓库</span>
          <span class="content-box-info">{{ orderDetailData.warehouseName }}</span>
        </div>
        <div>
          <span class="content-box-title">销售方式</span>
          <span class="content-box-info">-</span>
        </div>
        <div>
          <span class="content-box-title">包装规格</span>
          <span class="content-box-info">{{ orderDetailData.packing }}</span>
        </div>
        <div>
          <span class="content-box-title">销售单价（含税）</span>
          <span class="content-box-info"><span class="price-color">{{ $utils.amount(orderDetailData.price) }}</span>元/{{ orderDetailData.measureUnit }}</span>
        </div>
        <div>
          <span class="content-box-title">激励单价（含税）</span>
          <span class="content-box-info">
            <span class="price-color">{{ orderDetailData.incentiveUnit?$utils.amount(orderDetailData.incentiveUnit): "0.00"}}</span>元/{{ orderDetailData.measureUnit }}
          </span>
        </div>
        <div>
          <span class="content-box-title">销售金额（含税）</span>
          <span class="content-box-info"> <span class="price-color">{{ $utils.amount(orderDetailData.amount) }}</span>元</span>
        </div>
      </div>
      <div class="title-box">
        <h1 style="font-weight: bold;">物流</h1>
        <img src="@/assets/imgs/plansale/3.1 返回1@2x.png" alt="" @click="toggleShow1">
      </div>
      <div class="content-box" v-if="showDetails1">
        <div>
          <span class="content-box-title">交货方式</span>
          <span class="content-box-info">
            <span v-for="(item, index) in sendWays" :key="index" @click="radioBtnClick(item.code)">{{ item.name }}</span>
          </span>
        </div>
        <div>
          <span class="content-box-title">送达方</span>
          <span class="content-box-info">-</span>
        </div>
        <div>
          <span class="content-box-title">联系人</span>
          <span class="content-box-info">-</span>
        </div>
        <div>
          <span class="content-box-title">提货人</span>
          <span class="content-box-info">-</span>
        </div>
      </div>
      <div class="title-box">
        <h1 style="font-weight: bold;">支付方式</h1>
        <img src="@/assets/imgs/plansale/3.1 返回1@2x.png" alt="" @click="toggleShow2">
      </div>
      <div class="content-box" v-if="showDetails2">
        <div>
          <span class="content-box-title">付款方式</span>
          <span class="content-box-info">全额预付</span>
        </div>
        <div>
          <span class="content-box-title">支付方式</span>
          <span class="content-box-info">ERP余额支付</span>
        </div>
      </div>
      <div class="title-box">
        <h1>发票信息</h1>
        <img src="@/assets/imgs/plansale/3.1 返回1@2x.png" alt="" @click="toggleShow3">
      </div>
      <div class="content-box" v-if="showDetails3">
        <div>
          <span class="content-box-title">发票类型</span>
          <span class="content-box-info">{{invoiceInfo.invoiceHead}}</span>
        </div>
        <div>
          <span class="content-box-title">公司税号</span>
          <span class="content-box-info">{{invoiceInfo.invoiceAccountNo}}</span>
        </div>
      </div>
      <div class="title-box">
        <h1 style="font-weight: bold;">备注信息</h1>
        <img src="@/assets/imgs/plansale/3.1 返回1@2x.png" alt="" @click="toggleShow4">
      </div>
      <div class="content-box" v-if="showDetails4">
        <van-field v-model="form.remark" rows="5" autosize type="textarea" placeholder="备注信息" />
      </div>
      <div class="title-box">
        <h1 style="font-weight: bold;">结算信息</h1>
        <img src="@/assets/imgs/plansale/3.1 返回1@2x.png" alt="" @click="toggleShow5">
      </div>
      <div class="content-box" v-if="showDetails5">
        <div>
          <span class="content-box-title">1个商品，金额</span>
          <span class="content-box-info">
            <span class="red-color">{{ $utils.amount(orderDetailData.price) }}元</span>
          </span>
        </div>
        <div>
          <span class="content-box-title">订单总量</span>
          <span class="content-box-info">
            <span class="red-color">{{ orderDetailData.quantity }}{{ orderDetailData.measureUnit }}</span>
          </span>
        </div>
      </div>

      <div class="end-box">
        <van-checkbox class="checkbox" v-model="orderAgreementCheck" shape="square">接受交易协议<a href="javascript:;" class="checkbox-a" @click.stop="viewAgreement('02', constants.orderAgreementTemplateId)">查看订单协议</a>
        </van-checkbox>
      </div>
    </div>

    <div class="btn-order">
      <span>￥<span class="btn-order-pice">{{ $utils.amount(orderDetailData.amount) }}</span></span>
      <div class="btn-style" @click="submit()">提交订单</div>
    </div>
    <viewAgreement ref="Agreement"></viewAgreement>
  </div>
</template>
<script>
import Header from "./components/Header";
import viewAgreement from "../../components/viewAgreement";
import planSaleApi from "@/request/planSaleApi";
export default {
  components: {
    Header,
    viewAgreement,
  },
  data() {
    return {
      showDetails: true, // 控制价格详情是否显示
      showDetails1: true, // 控制价格详情是否显示
      showDetails2: true, // 控制价格详情是否显示
      showDetails3: true, // 控制价格详情是否显示
      showDetails4: true, // 控制价格详情是否显示
      showDetails5: true, // 控制价格详情是否显示
      constants: this.$common.interfacePath,
      orderAgreementCheck: true,
      qualityAgreementCheck: false,
      submitNum: 0,
      codeSet: {
        saleModeEnum: [
          {
            itemCode: "02",
            itemName: "定价",
          },
          {
            itemCode: "01",
            itemName: "挂牌",
          },
          {
            itemCode: "03",
            itemName: "翻牌",
          },
        ],
      },
      sendWays: [],
      sendAddress: [],
      sendWaysCode: "",
      sendAddressIndex: -1,
      freightUnit: "",
      previewData: {
        erpAccountBalance: null,
      },
      invoiceInfo: {},
      orderDetailData: {}, //激励
      orderPrimaryData: {},
      queryData: {}, //url查询参数
      shouldPayTotal: 0,
      sendFee: 0, //运费
      form: {
        contractNo: "",
        remark: "",
      },
      priceIncentiveList: {},
      destinationCode: "",
      contactCode: "",
      consigneeCode: "",
      payerCode: "",
      receiverCode: "",
      destinationList: [], // 送达方
      contactList: [], // 联系人
      consigneeList: [], // 提货方
      payerList: [], // 付款方
      receiverList: [], // 收款方

      destinationCodeShow: false,
      contactListShow: false,
      consigneeListCodeShow: false,
    };
  },
  mounted() {},
  created() {
    if (this.$route.query.contractNo) {
      this.form.contractNo = this.$route.query.contractNo;
    }
    console.log("destinationList", this.destinationList);
    this.getOrderPreview();
  },
  methods: {
    toggleShow() {
      this.showDetails = !this.showDetails; // 切换显示状态
    },
    toggleShow1() {
      this.showDetails1 = !this.showDetails1; // 切换显示状态
    },
    toggleShow2() {
      this.showDetails2 = !this.showDetails2; // 切换显示状态
    },
    toggleShow3() {
      this.showDetails3 = !this.showDetails3; // 切换显示状态
    },
    toggleShow4() {
      this.showDetails4 = !this.showDetails4; // 切换显示状态
    },
    toggleShow5() {
      this.showDetails5 = !this.showDetails5; // 切换显示状态
    },
    getOrderPreview() {
      let params = {
        contractId: this.$route.query.contractId,
        tradeId: this.$route.query.tradeId,
        stockId: this.$route.query.stockId,
        stationName: this.$route.query.stationName,
        stationCode: this.$route.query.stationCode,
        quantity: this.$route.query.quantity,
        price: this.$route.query.price,
      };
      this.queryData = params;
      planSaleApi.getOrderPreview(params).then((res) => {
        if (res.returnCode == "0") {
          this.orderPrimaryData = res.result;
          console.log(res.result.orderDetailInfoList[0]);

          this.orderDetailData = res.result.orderDetailInfoList[0];
          this.invoiceInfo = res.result.invoiceInfo;
          this.sendAddress = res.result.deliveryAddressConfigOption;
          var incentiveAmount = this.$calculator.arithmeticTim(
            this.orderDetailData.incentiveUnit,
            this.orderDetailData.quantity,
            2
          );
          this.shouldPayTotal = this.$calculator.arithmeticSub(
            this.orderDetailData.amount,
            incentiveAmount,
            2
          );
          // a: this.sendFee ? Number(this.quantity||0)  : 0,
          this.sendWays = res.result.multiDeliveryModeArr.map((code) => {
            if (code == "1") {
              return {
                name: "自提",
                code,
              };
            } else if (code == "2") {
              return {
                name: "配送",
                code,
              };
            }
          });
          res.result.multiDeliveryModeArr.includes("1") &&
            (this.sendWaysCode = "1");
          this.form.contractNo = this.orderDetailData.contractNo;

          this.previewData.erpAccountBalance = res.result.erpAccountBalance;
          this.priceIncentiveList = res.result.priceIncentiveList[0];

          /**送达方区域开始*/
          // this.destinationList = res.result.destinationList || []
          res.result.destinationList.forEach((item) => {
            this.destinationList.push({
              text: item.name,
              value: item.code,
            });
          });
          // this.destinationList = res.result.destinationList;
          console.log("00destinationList", this.destinationList);
          // UAT整改12/14新增默认显示
          // 送达方默认显示
          this.destinationCode = res.result.destinationList[0].code;
          /*送达方区域结束*/

          res.result.consigneeList.forEach((item) => {
            this.consigneeList.push({
              text: item.name,
              value: item.code,
            });
          });
          res.result.contactList.forEach((item) => {
            this.contactList.push({
              text: item.name,
              value: item.code,
            });
          });

          // console.log("contactList--0000", this.contactList)
          // this.consigneeCode=res.result.consigneeList[0].code;
          // this.contactCode=res.result.contactList[0].code;
          // this.consigneeList = res.result.consigneeList || []
          // this.contactList = res.result.contactList || []
          // console.log("eee", this.contactList);

          /*付款方区域开始*/
          this.payerList = res.result.payerList || [];
          // 付款方默认显示
          this.payerCode = res.result.payerList[0].code;
          /*付款方区域结束*/

          /*收票方开始*/
          this.receiverList = res.result.receiverList || [];
          /*收票方默认显示*/
          this.receiverCode = res.result.receiverList[0].code;
          /*收票方结束*/
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    changeSelChange(item, type) {
      // console.log("jj", item)
      this.destinationCodeShow = true;
      this.destinationCode = item.name;
      let map = {
        1: "destinationName",
        2: "contactName",
        3: "consigneeName",
        4: "payerName",
        5: "receiverName",
      };
      let name = map[type];
      this[name] = item.name;
    },
    radioBtnClick(code) {
      console.log("code", code);
      this.sendWaysCode = code;
      if (code == "1") {
        this.sendAddressIndex = -1;
      }
    },
    addressClick(index) {
      this.sendAddressIndex = index;
    },
    submit() {
      if (!this.orderAgreementCheck) {
        return this.$toast.fail("请阅读并同意订单协议");
      }
      var agreementSignList = []; // 同意协议列表
      if (this.orderAgreementCheck) {
        agreementSignList.push({
          templateId: "XY200527114189765",
          agreementName: "订单协议",
          agreementType: "02",
        });
      }
      if (this.qualityAgreementCheck) {
        agreementSignList.push({
          templateId: "XY200527114689765",
          agreementName: "质量保障确认书",
          agreementType: "02",
        });
      }
      if (!this.destinationCode) {
        return this.$toast.fail("送达方不能为空");
      }
      // if (!this.contactCode) {
      //   return this.$toast.fail("联系人不能为空")
      // }
      // if (!this.consigneeCode) {
      //   return this.$toast.fail("提货人不能为空")
      // }
      // if (!this.payerCode) {
      //   return this.$toast.fail("付款方不能为空");
      // }
      // if (!this.receiverCode) {
      //   return this.$toast.fail("收款方不能为空");
      // }
      // 判断如果点击多次进行拦截
      if (this.submitNum == 1) {
        return false;
      }
      let params = {
        ...this.form,
        contractId: this.$route.query.contractId,
        tradeId: this.$route.query.tradeId,
        stockId: this.$route.query.stockId,
        stationName: this.$route.query.stationName,
        stationCode: this.$route.query.stationCode,
        quantity: this.$route.query.quantity,
        price: this.$route.query.price,
        deliveryMode: this.sendWaysCode, 

        deliveryAddress:
          this.sendAddressIndex !== -1
            ? this.sendAddress[this.sendAddressIndex].address
            : "",
        agreementSignList,
        confirmData: {
          freightUnit: this.sendFee,
          copartnerInfo: {
            destinationCode: this.destinationCode,
            destinationName: this.destinationName,
            contactCode: this.contactCode,
            contactName: this.contactName,
            consigneeCode: this.consigneeCode,
            consigneeName: this.consigneeName,
            payerCode: this.payerCode,
            // payerName: this.payerName,
            receiverCode: this.receiverCode,
            receiverName: this.receiverName,
            
          },
        },
      };
      this.submitNum = 1;
      planSaleApi.submitOrder(params).then((res) => {
        if (res.returnCode == "0") {
          //  this.$Message.success("提交订单成功");
          this.submitNum = 0;
          this.$dialog
            .alert({
              title: "提示",
              message: "提交订单成功",
            })
            .then(() => {
              this.$router.push("/order");
            })
            .catch(() => {
              // this.$router.push("/planSale");
            });
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    viewAgreement(agreementType, templateId) {
      this.$refs.Agreement.viewAgreement(agreementType, templateId);
    },
  },
};
</script>
<style lang="stylus" scoped>
.bgw {
  background: #ffffff;
}

.price {
  color: #E12020;
}

.redColor {
  color: #E12020;
  font-size: 36px;
}

.text {
  color: #333;
  font-size: 30px;
}

.title {
  color: #333;
  font-size: 30px;
  margin-bottom: 20px;
  font-weight: 600;
}

.main-cont .van-row {
  line-height: 50px;
}

.destination .van-row {
  line-height: 60px;
}

.remark >>> .van-field__control {
  border: 1px solid #999999;
  border-radius: 10px;
  padding: 10px;
  font-size: 28px;
}

.remark >>> .van-field__label {
  font-size: 28px;
  width: 60px;
}

.pro {
  padding-bottom: 80px;
  // margin-bottom: 20px;
}

.pro-list >>> .van-checkbox__icon, .pro-list >>> .van-checkbox {
  font-size: 30px;
}

.pro-list >>> .van-checkbox__label {
  color: #E12020;
}

.checkbox {
  margin-top: 40px;
}

.pro-list {
  line-height: 60px;

  .pro-list-left {
    display: inline-block;
    width: 40%;
    text-align: right;
  }

  .pro-list-right {
    display: inline-block;
    width: 55%;
    text-align: right;
  }
}

.btn-order {
  position: absolute;
  bottom: 10px;
  width: 100%;
  background: #fff;

  span {
    text-align: left;
    display: inline-block;
    width: 35%;
  }

  .card-btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 120px;
    margin-left: 10px;

    .btn {
      width: 60%;
      height: 80px;
      background: linear-gradient(132deg, #EF9623 0%, #E12020 100%);
      color: #ffffff;
      font-size: 32px;
      border-radius: 40px;
    }
  }
}

.viewAgreement {
  color: #3a70cc;
  text-decoration: underline;
  margin-left: 5px;
}

.main-cont1 {
  // flex: 1;
  font-size: 28px;
  padding-bottom: 32px;
}

.title-box {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 28px 0;
  padding: 0 32px;

  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #333333;
  }

  img {
    width: 32px;
    height: 32px;
  }
}

.content-box {
  padding: 32px;
  background: #FFFFFF;

  .content-box-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    line-height: 40px;
    color: #666666;
    margin-right: 48px;
  }

  .content-box-info {
    width: 70%;
    flex: 1;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #333333;
    line-height: 40px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  > div {
    display: flex;
  }

  > div:nth-child(n+2) {
    margin-top: 40px;
  }

  .price-color {
    color: #FF5500;
  }

  .red-color {
    color: #E43C46;
  }

  /deep/ .van-cell {
    padding: 0;
    font-size: 28px;
  }
}

.end-box {
  height: 66px;
  margin: 28px 0 130px;
  padding: 0 32px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #333333;

  .checkbox {
    height: 100%;

    .checkbox-a {
      color: #e00612;
    }
  }
}

.btn-order {
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  height: 130px;
  line-height: 130px;
  background: #FFFFFF;
  box-shadow: 0px -1px 0px 0px #EEEEEE;
  border-radius: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;

  .btn-style {
    width: 236px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    background: #E0000C;
    border-radius: 40px 40px 40px 40px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #FFFFFF;
  }

  >span {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #FF5500;

    .btn-order-pice {
      font-size: 48px;
    }
  }
}
</style>
